<template>
  <div>
    <v-row dense>
      <v-col cols="12">
        <p class="text-subtitle-2 mb-2">{{ $t("links") }}</p>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <text-field label="Facebook" v-model="settings.facebook" />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <text-field label="Instagram" v-model="settings.instagram" />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <text-field label="Twitter" v-model="settings.twitter" />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <text-field label="Linkedin" v-model="settings.linkedin" />
      </v-col>
      <v-col cols="12">
        <v-divider class="my-2" />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <text-field label="Google Play" v-model="settings.google" />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <text-field label="Apple Store" v-model="settings.apple" />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <text-field label="Huawei Store" v-model="settings.huawei" />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <text-field :label="$t('web_application')" v-model="settings.webapp" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "LinksSection",
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },
};
</script>
